import { useTranslation } from "react-i18next";
import { ReportBlock } from "./ReportBlock";
import { EquityBlock } from "./EquityBlock";
import { ExportBar } from "./ExportBar";
import { MonthlyPack } from "./MonthlyPack";
import { SegmentTable } from "./SegmentTable";

// التقرير المالي المفتوح فقط بدل كومة كل القوائم في صفحة واحدة.
export const AcctReportSection = ({ tab, data, range }) => {
  const { t } = useTranslation();
  const { pl, bs, cf, aging, segments, equity } = data;

  if (tab === "income")
    return pl ? (
      <ReportBlock
        testId="report-pl"
        titleKey="acct.report.incomeStatement"
        tone={Number(pl.net_profit) >= 0 ? "text-success" : "text-destructive"}
        items={[
          { key: "revenue", value: pl.revenue },
          { key: "cost_of_sales", value: pl.cost_of_sales },
          { key: "gross_profit", value: pl.gross_profit },
          { key: "operating_expenses", value: pl.operating_expenses },
          { key: "non_operating", value: pl.non_operating },
          { key: "net_profit", value: pl.net_profit, strong: true },
        ]}
      />
    ) : null;

  if (tab === "balance")
    return bs ? (
      <ReportBlock
        testId="report-bs"
        titleKey="acct.report.balanceSheet"
        tone={bs.balanced ? "text-success" : "text-destructive"}
        items={[
          { key: "assets", value: bs.assets },
          { key: "liabilities", value: bs.liabilities },
          { key: "equity", value: bs.equity },
          { key: "current_year_result", value: bs.current_year_result },
          { key: "equity_and_result", value: bs.equity_and_result, strong: true },
        ]}
      />
    ) : null;

  if (tab === "cashflow")
    return cf ? (
      <ReportBlock
        testId="report-cf"
        titleKey="acct.report.cashFlow"
        items={[
          { key: "operating", value: cf.operating },
          { key: "investing", value: cf.investing },
          { key: "financing", value: cf.financing },
          { key: "net_change", value: cf.net_change, strong: true },
        ]}
      />
    ) : null;

  if (tab === "aging")
    return aging ? (
      <ReportBlock
        testId="report-aging"
        titleKey="acct.report.aging"
        items={[
          ...Object.entries(aging.buckets).map(([key, value]) => ({ key, value })),
          { key: "ecl_provision", value: aging.ecl_provision },
          { key: "total", value: aging.total, strong: true },
        ]}
      />
    ) : null;

  if (tab === "equity") return <EquityBlock equity={equity} />;
  if (tab === "segments") return <SegmentTable segments={segments} />;

  return (
    <div className="grid gap-4">
      <ExportBar range={range} />
      <MonthlyPack />
    </div>
  );
};
